module.exports = __webpack_public_path__ + "static/media/city-map-sml.3cd80922.jpg";